module.exports = __webpack_public_path__ + "static/media/01service.374ee14d.svg";